import React from 'react';
import { Plugin, Template, TemplatePlaceholder } from '@devexpress/dx-react-core';
import { Box } from '@mui/material';

import {
  getLineScheduleGridCheckedBundleGuids,
  getLineScheduleGridRowsByLineGuid,
  isGroupedProductionComponentInstanceRow,
} from '../../../selectors/lineScheduleGrid';
import { collapseRows } from '../../../store/lineScheduleGridSlice';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { LineSelector } from '../../LineSelector';
import { CollapseAllButton } from '../CollapseAllButton';
import { DownloadProductionPackageButton } from '../DownloadProductionPackageButton';
import { SetStatus } from '../SetStatus';

interface LineScheduleGridToolbarPluginProps {
  readonly lineGuidFilter: string | null;
  readonly setLineGuidFilter: (lineGuidFilter: string) => void;
}

export function LineScheduleGridToolbarPlugin(props: LineScheduleGridToolbarPluginProps) {
  const { lineGuidFilter, setLineGuidFilter } = props;
  const dispatch = useAppDispatch();
  const checkedBundleGuids = useAppSelector(getLineScheduleGridCheckedBundleGuids);

  const lineScheduleGridRowsByLine = useAppSelector(getLineScheduleGridRowsByLineGuid);
  const allExpandableOrCollapsableRowIds =
    lineGuidFilter === null
      ? []
      : (lineScheduleGridRowsByLine[lineGuidFilter] ?? [])
          .filter((row) => !isGroupedProductionComponentInstanceRow(row.rowId))
          .map((row) => row.rowId);

  return (
    <Plugin name="LineScheduleGridToolbar" dependencies={[{ name: 'Toolbar' }]}>
      <Template name="toolbarContent">
        <Box sx={{ width: 300, mr: 1 }}>
          <LineSelector
            selectedLineGuid={lineGuidFilter}
            submit={(lineGuid) => void setLineGuidFilter(lineGuid)}
            placeholderTextOverride="Select a line to show in the grid"
          />
        </Box>

        <Box sx={{ width: 380 }}>
          <SetStatus
            checkedBundleGuids={checkedBundleGuids}
            options={['Scheduled', 'StartedAssembly', 'FinishedAssembly', 'StoredOnYard']}
          />
        </Box>

        <DownloadProductionPackageButton
          bundleGuids={checkedBundleGuids}
          productionArtifactsContext="ScheduleLineGroup"
        />
        <TemplatePlaceholder />
        <CollapseAllButton
          collapseAll={(rowIds) => dispatch(collapseRows(rowIds))}
          allCollapsableRowIds={allExpandableOrCollapsableRowIds}
        />
      </Template>
    </Plugin>
  );
}
